module.exports = __webpack_public_path__ + "static/media/attendance_summary_calling.b74c21c4.svg";